import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { ApiServiceService } from '../service/api-service.service';
import { configuration } from 'src/configuration';

@Component({
  selector: 'app-properties',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.css']
})
export class PropertiesComponent implements AfterViewInit, OnInit {

  // First Set of Dropdowns
  selectedOption: string = '';
  isDropdownOpen: boolean = false;
  propertyTypes: string[] = ['Residential', 'Commercial', 'Land', 'Industrial'];

  // Second Set of Dropdowns
  priceLimitselectedOption: string = '';
  isPriceLimitDropdownOpen: boolean = false;
  priceLimit: string[] = ['100 AED', '10,000 AED', '50,000 AED'];

  // Other properties
  propertyList: any = [];
  limit: any = configuration.PAGE_LIMIT;
  offset: any = configuration.OFFSET;

  constructor(public shared: SharedService, private elRef: ElementRef, private renderer: Renderer2, public apiService: ApiServiceService) {
    this.shared.isWhiteMenu = false;
  }

  ngOnInit(): void {
    this.renderer.listen('document', 'click', (event: Event) => {
      const target = event.target as HTMLElement;
      if (!this.elRef.nativeElement.contains(target)) {
        this.isDropdownOpen = false;
        this.isPriceLimitDropdownOpen = false;
      }
    });
    this.getPropertyList();
  }

  ngAfterViewInit(): void {
    this.shared.includeMainScript();
  }

  // Methods for the First Set of Dropdowns
  onDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.custom-dropdown');
    if (!dropdown.contains(event.target as Node)) {
      this.isDropdownOpen = false;
    }
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectOption(option: string): void {
    this.selectedOption = option;
    this.isDropdownOpen = false;
  }

  // Methods for the Second Set of Dropdowns
  onPriceLimitDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.price-limit-dropdown');
    if (!dropdown.contains(event.target as Node)) {
      this.isPriceLimitDropdownOpen = false;
    }
  }

  priceLimitToggleDropdown(): void {
    this.isPriceLimitDropdownOpen = !this.isPriceLimitDropdownOpen;
  }

  priceLimitSelectOption(option: string): void {
    this.priceLimitselectedOption = option;
    this.isPriceLimitDropdownOpen = false;
  }

  async getPropertyList() {
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.PROPERTY_LIST, {
      limit: this.limit,
      offset: this.offset
    });
    if (res && !res.error && res.data) {
      this.propertyList = res.data.rows;
    }
  }
}
